module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Novo Projeto de Pesquisa'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Título*",
      "counter": "400",
      "rules": _vm.obrigatorio.concat( _vm.max400caracteres)
    },
    model: {
      value: (_vm.projetoPesquisa.titulo),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "titulo", $$v)
      },
      expression: "projetoPesquisa.titulo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Sigla",
      "counter": "20",
      "rules": _vm.max20caracteres
    },
    model: {
      value: (_vm.projetoPesquisa.sigla),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "sigla", $$v)
      },
      expression: "projetoPesquisa.sigla"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Área do Conhecimento*",
      "items": _vm.listaAreaDoConhecimento,
      "return-object": "",
      "item-text": "descricao",
      "item-value": "id",
      "rules": _vm.obrigatorio,
      "hint": "O projeto deve ser registrado na área do conhecimento pertinente a sua temática."
    },
    on: {
      "input": function($event) {
        return _vm.getNomesDasAreas(_vm.projetoPesquisa.areaConhecimento.id)
      }
    },
    model: {
      value: (_vm.projetoPesquisa.areaConhecimento),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "areaConhecimento", $$v)
      },
      expression: "projetoPesquisa.areaConhecimento"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Nome da Área*",
      "return-object": "",
      "items": _vm.listaNomeArea,
      "item-text": "descricao",
      "item-value": "id",
      "rules": _vm.obrigatorio,
      "disabled": _vm.nomeAreaDisabled
    },
    on: {
      "input": function($event) {
        return _vm.getNomesDasSubareas(_vm.projetoPesquisa.nomeArea.id)
      }
    },
    model: {
      value: (_vm.projetoPesquisa.nomeArea),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "nomeArea", $$v)
      },
      expression: "projetoPesquisa.nomeArea"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Nome da Subárea*",
      "return-object": "",
      "items": _vm.listaNomeSubarea,
      "item-text": "descricao",
      "item-value": "id",
      "rules": _vm.obrigatorio,
      "disabled": _vm.nomeSubareaDisabled || _vm.listaNomeSubarea.length === 0
    },
    model: {
      value: (_vm.projetoPesquisa.nomeSubarea),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "nomeSubarea", $$v)
      },
      expression: "projetoPesquisa.nomeSubarea"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Linha de Pesquisa no Programa de Pós-Graduação*",
      "return-object": "",
      "items": _vm.listaLinhaPesquisaPPG,
      "disabled": "",
      "hint": "Esta opção está indisponível no momento.",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.projetoPesquisa.linhaPesquisaPPG),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "linhaPesquisaPPG", $$v)
      },
      expression: "projetoPesquisa.linhaPesquisaPPG"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-dialog', {
    attrs: {
      "label": "Data de início*",
      "rules": _vm.obrigatorio
    },
    model: {
      value: (_vm.projetoPesquisa.dataInicio),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "dataInicio", $$v)
      },
      expression: "projetoPesquisa.dataInicio"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field-integer', {
    attrs: {
      "label": "Prazo em meses*",
      "properties": {
        rules: _vm.obrigatorio.concat( _vm.numerico)
      }
    },
    model: {
      value: (_vm.projetoPesquisa.prazoMeses),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "prazoMeses", $$v)
      },
      expression: "projetoPesquisa.prazoMeses"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Palavras-chaves*",
      "counter": "300",
      "rows": 1,
      "auto-grow": true,
      "rules": _vm.obrigatorio.concat( _vm.max300caracteres, _vm.palavrasChaves),
      "hint": "Indique no mínimo 03 e no máximo 06 palavras que podem ser relacionadas ao escopo do projeto. As palavras devem ser separadas somente por vírgulas e sem ponto ao final."
    },
    model: {
      value: (_vm.projetoPesquisa.palavrasChaves),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "palavrasChaves", $$v)
      },
      expression: "projetoPesquisa.palavrasChaves"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Resumo*",
      "counter": "2000",
      "rows": 4,
      "auto-grow": true,
      "rules": _vm.obrigatorio.concat( _vm.max2000caracteres),
      "hint": "Deve conter uma descrição do projeto, incluindo sua relevância."
    },
    model: {
      value: (_vm.projetoPesquisa.resumo),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "resumo", $$v)
      },
      expression: "projetoPesquisa.resumo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Tenho conhecimento da obrigatoriedade (ou não) de cadastro do projeto no Comitê de Ética em Pesquisa (CEP) e/ou Comitê de Ética no Uso de Animais (CEUA) e/ou SisGen.*",
      "rules": _vm.obrigatorio
    },
    model: {
      value: (_vm.projetoPesquisa.conhecimentoCepCeuaSisgen),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "conhecimentoCepCeuaSisgen", $$v)
      },
      expression: "projetoPesquisa.conhecimentoCepCeuaSisgen"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "divisorBotoes"
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.novoProjetoPesquisa()
      }
    }
  }, [_vm._v("Criar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-815b6f9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pesquisa/novo-projeto-pesquisa.vue
// module id = 792
// module chunks = 0